<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'forwarderReviews'">
    <!-- <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb> -->
    <div style="margin-top: 30px;">
        <app-order-detail-component [order]="order" [isClosedSale]="false" *ngIf="order"></app-order-detail-component>
    </div>
</app-user-dashboard>
<p-blockUI [blocked]="loading"></p-blockUI>